import React from "react";
import {Form} from "formik";
import {Button, TextField, PasswordField, Divider} from "@reside/ui";

import {StyledButtonLinkWrapper, StyledLink} from "./style";
import {ButtonLink} from "../../atoms/button-link";
import {RequestError} from "../../atoms/error";

export const PageAdminLoginForm = ({
  error,
  isLoading,
}: {
  error: any;
  isLoading: boolean;
}): JSX.Element => {
  return (
    <Form>
      <TextField
        name="email"
        type="email"
        label="Email Address"
        testId="input-email"
      />
      <PasswordField name="password" label="Password" testId="input-password" />
      <StyledLink to="/request-reset-email" data-test-id="forgot-password">
        Forgot password?
      </StyledLink>
      {error && <RequestError payload={error} data-test-id="validator-error" />}

      <Button
        testId="loginButton"
        type="submit"
        color="primary"
        disabled={isLoading}
        style={{width: "100%", marginTop: "32px", marginBottom: "32px"}}
      >
        {isLoading ? "Processing..." : "Sign in with email"}
      </Button>

      <Divider text="OR" />

      <StyledButtonLinkWrapper>
        <ButtonLink
          to="/admin/sso-login-form"
          style={{
            width: "100%",
          }}
        >
          Sign in with SSO
        </ButtonLink>
      </StyledButtonLinkWrapper>
    </Form>
  );
};
